import {
  ENV,
  Environment,
  mockServerPort,
} from '@backoffice-frontend/environment'

const MobileAppFlavorConfigStages: Record<Environment, string> = {
  [Environment.local]: `http://localhost:${mockServerPort}/api/mobile-app-flavor-config`,
  [Environment.test]: `http://localhost:${mockServerPort}/api/mobile-app-flavor-config`,
  // This is a POC feature that is only available in the DEV environment at the moment.
  // Integration and Production environments do not have backend support yet.
  [Environment.development]: `https://app-flavor-config.mobile-platform.dev.moia-group.io/bofe`,
  [Environment.integration]: `https://app-flavor-config.mobile-platform.int.moia-group.io/bofe`,
  [Environment.production]: `https://app-flavor-config.mobile-platform.prd.moia-group.io/bofe`,
  [Environment['production.us-east-1']]:
    `https://app-flavor-config.mobile-platform.prd.moia-group.io/bofe`,
}

const Host = MobileAppFlavorConfigStages[ENV]

export const SCHEMA_VERSION = 'v0'

export const MobileAppFlavorConfigEndpoints = {
  GetConfig: `${Host}/latest/${SCHEMA_VERSION}/universal.json`,
  ProposeUpdateConfig: `${Host}/update`,
  GetFlavorPRs: (flavor: string) => `${Host}/prs/${flavor}`,
  GetPlatformSchema: (platform: string) =>
    `${Host}/latest/${SCHEMA_VERSION}/schemas/${platform}.schema.json`,
  GetConfigContext: `${Host}/config/context`,
}
